import Navbar from '@/components/Navbar';
import { Skeleton } from '@/components/ui/skeleton';

interface DashboardSkeletonProps {
  /** When true, omits the outer page chrome + Navbar (use inside a parent that already renders them). */
  bodyOnly?: boolean;
}

const SkeletonBody = () => (
  <main className="container mx-auto px-4 py-4 md:px-6 md:py-6">
    {/* Filter bar skeleton */}
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <Skeleton className="h-8 w-24 rounded-md" />
      <Skeleton className="h-8 w-20 rounded-md" />
      <Skeleton className="h-8 w-20 rounded-md" />
      <Skeleton className="h-8 w-32 rounded-md" />
    </div>
    {/* Table rows skeleton */}
    <div className="space-y-2">
      {Array.from({ length: 8 }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full rounded-lg" />
      ))}
    </div>
  </main>
);

/**
 * Suspense fallback for the authenticated dashboard. Renders the navbar and a
 * skeleton table so the user does not see a blank flash while the dashboard
 * chunk + data are loading. Pass `bodyOnly` when used inside a page that
 * already renders a Navbar to avoid stacking two.
 */
const DashboardSkeleton = ({ bodyOnly = false }: DashboardSkeletonProps) => {
  if (bodyOnly) return <SkeletonBody />;
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <SkeletonBody />
    </div>
  );
};

export default DashboardSkeleton;
